
import React from 'react';
import Layout from '@/components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import OptimizedFinanceProcurementList from '@/components/finance/OptimizedFinanceProcurementList';

const FinanceApprovalsPending = () => {
  return (
    <Layout>
      <div className="w-full max-w-full py-8">
        <h1 className="text-3xl font-bold mb-8">Pending Approvals</h1>
        
        <Card className="w-full">
          <CardHeader>
            <CardTitle>Purchase Requisition Approval</CardTitle>
          </CardHeader>
          <CardContent>
            <OptimizedFinanceProcurementList status="pending" />
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default FinanceApprovalsPending;
